import { useState } from 'react'
import Logger from 'lib/logger'

export const useLogger = (prefix = 'Barstool') => {
  const [logger] = useState(new Logger(prefix))
  return logger
}
